import { render, staticRenderFns } from "./bank_statement.vue?vue&type=template&id=116e5b9f&scoped=true&"
import script from "./bank_statement.vue?vue&type=script&lang=js&"
export * from "./bank_statement.vue?vue&type=script&lang=js&"
import style0 from "./bank_statement.vue?vue&type=style&index=0&id=116e5b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e5b9f",
  null
  
)

export default component.exports